/*    
<summary>
  This functional component "ChooseGroupPopupHOC" provides props to the child component.
  1. State "showAddDevicePopup" that manages the show/hide of pop up
  2. Function "addDeviceToggleHandler" to toggle the show/hide popup state "showAddDevicePopup"
  Developer:Aashish Singh, Created Date:29-March-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";

const ChooseGroupPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showChooseGroupPopup, setShowChooseGroupPopup] =
      useState<boolean>(false);

    const chooseGroupToggleHandler = () => {
      setShowChooseGroupPopup(!showChooseGroupPopup);
    };

    return (
      <Component
        showChooseGroupPopup={showChooseGroupPopup}
        chooseGroupToggleHandler={chooseGroupToggleHandler}
        {...props}
      />
    );
  };

export default ChooseGroupPopupHOC;
